export default {
    showSavedData: state => state.showSavedData,
    showLoadingModal: state => state.showLoadingModal,
    showErrorModal: state => state.showErrorModal,
    showUnauthorizedModal: state => state.showUnauthorizedModal,
    showDisclaimerModal: state => state.showDisclaimerModal,
    showNoDiagnoseFoundModal: state => state.showNoDiagnoseFoundModal,
    actionToRetry: state => state.actionToRetry,

    patient: state => state.patient,
    patientId: state => state.patient.id,


    anfallsanamnese: state => state.anfallsanamnese,
    technischeUntersuchungen: state => state.technischeUntersuchungen,
    diagnosestellung: state => state.diagnosestellung,
    therapie: state => state.therapie,

    diagnosestellungReachable: state => state.diagnosestellungReachable,
    therapieReachable: state => state.therapieReachable,

    showAnfaelleOverview: state => state.showAnfaelleOverview,
    showUntersuchungenOverview: state => state.showUntersuchungenOverview
}